import { type Variants } from 'framer-motion';

// TODO: These interaction animations are much easier
// to implement with CSS and should be refactored.
export const groupButtonDirVariants: Variants = {
    leftTapping: {
        width: 50,
        borderRadius: '100px',
        translateX: 0,
    },
    left: {
        width: 40,
        borderRadius: '50%',
        translateX: 0,
    },
    rightTapping: {
        width: 50,
        borderRadius: '100px',
        translateX: 30,
    },
    right: {
        width: 40,
        borderRadius: '50%',
        translateX: 40,
    },
};
